<template>
  <div class="receipt-container">
    <div v-if="isDataReady">
      <div
        v-for="(items, pageIndex) in hasil"
        :key="pageIndex"
        class="receipt-page"
      >
        <ReceiptHeader type="outlet" :data="outlet" />
        <div class="receipt-content">
          <div class="info-section">
            <div class="info-row">
              <div class="info-label">No. Retur:</div>
              <div class="info-value">{{ retur_bon.retur_number }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Tanggal:</div>
              <div class="info-value">
                {{ dateFormatter(retur_bon.created_at) }}
              </div>
            </div>
          </div>
          <div class="outgoing-detail" v-if="detail != null">
            <Toast />
            <div class="card print">
              <!-- Company Header -->
              <div class="company-header">
                <div class="logo">
                  <img src="/assets/images/logo.png" alt="mode_logo" />
                </div>
                <div class="company-info">
                  <h4 class="header-title"><b>MODE FASHION GROUP</b></h4>
                  <h6 class="header-subtitle">
                    {{ detail.summary.outlet_name }}
                  </h6>
                  <h6 class="header-subtitle">Telp. (061) 6643780</h6>
                </div>
              </div>
              <div class="border-header"></div>

              <!-- Title -->
              <div class="header-container">
                <h4 class="title">
                  <b v-if="detail.summary.type == 'RETURN'">BON RETUR BARANG</b>
                  <b v-else>TRANSFER ITEM</b>
                </h4>
              </div>

              <!-- Info Row -->
              <div class="summary-table-wrapper">
                <table class="summary-table">
                  <tr>
                    <td class="summary-label">Nomor Bon</td>
                    <td class="summary-value">
                      {{ detail.summary.doc_number }}
                    </td>
                    <td class="summary-label">
                      <span v-if="detail.summary.type == 'RETURN'"
                        >Gudang Tujuan</span
                      >
                      <span v-else>Outlet Tujuan</span>
                    </td>
                    <td class="summary-value">
                      <span v-if="detail.summary.type == 'RETURN'">{{
                        detail.summary.warehouse_name
                      }}</span>
                      <span v-else>{{
                        detail.summary.outlet_name_destination
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="summary-label">Tanggal Bon</td>
                    <td class="summary-value">
                      {{ moment(detail.summary.doc_date).format('DD-MM-YYYY') }}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
              </div>

              <!-- Item Table -->
              <div class="table-wrapper">
                <table class="detail-bon">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Kode</th>
                      <th>Nama</th>
                      <th>Kode Category</th>
                      <th>Kode Supplier</th>
                      <th>Harga</th>
                      <th>Jumlah</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(an_item, k) in detail.outlet_outbound" :key="k">
                      <td>{{ k + 1 }}</td>
                      <td>{{ an_item.item_code }}</td>
                      <td>{{ an_item.item_name }}</td>
                      <td>{{ an_item.category_code }}</td>
                      <td>{{ an_item.supplier_code }}</td>
                      <td>{{ an_item.price | currency }}</td>
                      <td>{{ an_item.qty }}</td>
                      <td>{{ an_item.total | currency }}</td>
                    </tr>
                    <tr class="totals-row">
                      <td colspan="6"><label>Total</label></td>
                      <td>{{ detail.summary.total_qty }}</td>
                      <td>{{ detail.summary.total_price | currency }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Signature Section -->
              <div class="signature-row">
                <div class="signature-col">
                  <label>Supervisor Toko</label>
                  <div class="signature-line"></div>
                </div>
                <div class="signature-col">
                  <label v-if="detail.summary.type == 'RETURN'"
                    >Penerima Gudang</label
                  >
                  <label v-else>Penerima Outlet</label>
                  <div class="signature-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'
var moment = require('moment')

export default {
  name: 'ReturBonReceipt',
  components: {
    ReceiptHeader
  },
  props: ['detail'],
  data() {
    return {
      moment: moment,
      ModeLogo: undefined,
      loading: true
    }
  },
  mounted() {
    setTimeout(function () {
      window.print()
    }, 500)
    setTimeout(function () {
      window.history.back()
    }, 500)
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.print {
  background: #fff;
  padding: 1.5rem;
  border-radius: 6px;
  max-width: 900px;
  margin: 0 auto;
}
.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  .logo {
    width: 60px;
    margin-right: 1rem;
    img {
      width: 100%;
      height: auto;
    }
  }
  .company-info {
    flex: 1;
    .header-title {
      font-size: 1.2rem;
      margin: 0;
    }
    .header-subtitle {
      font-size: 0.9rem;
      margin: 0;
    }
  }
}
.border-header {
  border-bottom: 2px solid #000;
  margin-bottom: 1rem;
}
.header-container {
  text-align: center;
  margin-bottom: 1rem;
  .title {
    font-size: 1.1rem;
    font-weight: bold;
    margin: 0;
  }
}
.summary-table-wrapper {
  margin-bottom: 1.5rem;
}
.summary-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  font-size: 1rem;
}
.summary-label {
  font-weight: 600;
  padding: 4px 12px 4px 0;
  text-align: left;
  width: 180px;
  color: #333;
}
.summary-value {
  padding: 4px 0 4px 0;
  text-align: left;
  color: #222;
}
.table-wrapper {
  margin-bottom: 2rem;
}
table.detail-bon {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  th,
  td {
    border: 1px solid #000;
    padding: 6px 8px;
    text-align: center;
  }
  th {
    background: #f8f8f8;
    font-weight: 600;
  }
  .totals-row td {
    font-weight: bold;
    background: #f0f0f0;
  }
}
.signature-row {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  .signature-col {
    flex: 1;
    text-align: center;
    label {
      font-size: 1rem;
      margin-bottom: 2.5rem;
      display: block;
    }
    .signature-line {
      border-top: 1px solid #000;
      width: 60%;
      margin: 2.5rem auto 0 auto;
      height: 2px;
    }
  }
}
@media print {
  .print {
    box-shadow: none;
    border-radius: 0;
    padding: 0.5rem;
    max-width: 100vw;
  }
  .company-header,
  .header-container,
  .summary-table-wrapper,
  .table-wrapper,
  .signature-row {
    page-break-inside: avoid;
  }
}
</style>
